import {
  IAnalyticsRepository,
  IAnalyticsRepositoryParams,
  IDeductionsByTypeAndReasonRepositoryResponse,
} from "@/core/repositories/analytics";

export class GetDeductionsByTypeAndReasonUseCase {
  constructor(private readonly repo: IAnalyticsRepository) {}

  async execute(
    params: IAnalyticsRepositoryParams
  ): Promise<IDeductionsByTypeAndReasonRepositoryResponse> {
    return this.repo.getDeductionsByTypeAndReason(params);
  }
}
